import React from 'react';
import AboutImg from './heroimage.png'; // Use your front-faced portrait image here

const AboutSection = () => {
  return (
    <div className="relative w-full min-h-[650px] bg-[#1a1515] text-white overflow-hidden flex flex-col md:flex-row items-center">
      
      {/* Left Side: Dramatic Focal Portrait Image */}
      <div className="relative w-full md:w-1/2 h-[400px] md:h-[650px] overflow-hidden">
        <img 
          src={AboutImg} 
          alt="Traditional Marathi Nauvari Elegance" 
          className="w-full h-full object-cover object-center transition-transform duration-700 hover:scale-102"
        />
        {/* Modern transparent fade to smooth out the middle border gap */}
        <div className="absolute inset-0 bg-gradient-to-t md:bg-gradient-to-r from-transparent via-[#1a1515]/30 to-[#1a1515]"></div>
      </div>

      {/* Right Side: Traditional & Modern Editorial Content */}
      <div className="w-full md:w-1/2 px-8 py-12 md:px-16 lg:px-24 space-y-6 z-10 bg-[#1a1515]">
        
        {/* Subtle Section Tag */}
        <div className="flex items-center space-x-2">
          <div className="w-6 h-[1px] bg-amber-500"></div>
          <span className="text-xs uppercase tracking-widest text-amber-400 font-medium">
            आमची गोष्ट • Our Legacy
          </span>
        </div>

        {/* Heading Section */}
        <div className="space-y-1">
          <h2 className="font-serif text-3xl md:text-5xl tracking-wide font-light text-neutral-100">
            Our Story
          </h2>
          <div className="w-12 h-[2px] bg-[#5c1d24] mt-2"></div>
        </div>
        
        {/* Traditional Touch: Devanagari Script Highlight */}
        <p className="font-serif text-xl md:text-2xl text-amber-100 leading-relaxed tracking-wide font-medium">
          तुळजाई माध्यमातून प्रत्येक धाग्यात विणलेली परंपरा, संस्कृती आणि आधुनिकतेचा सुरेख संगम.
        </p>
        
        {/* Modern Text Description */}
        <div className="space-y-4 text-sm text-neutral-300 leading-relaxed font-light">
          <p>
            Rooted in the historical handloom legacy of Maharashtra, Tuljai stands as a sanctuary for traditional textiles. We specialize in preserving the timeless structure of the classic 9-yard Nauvari, translating it carefully into bespoke contemporary silhouettes.
          </p>
          <p>
            Every weave tells a story of dedicated artisans, pure gold zari threads, and unmatched craftsmanship designed to carry our heritage into the modern era with effortless comfort.
          </p>
        </div>
        
        {/* Call to Action Button */}
        <div className="pt-4">
          <button className="relative group overflow-hidden px-8 py-3 border border-amber-500/40 text-amber-400 text-xs tracking-widest uppercase transition-colors duration-300 hover:text-white">
            <span className="absolute inset-0 w-full h-full bg-[#5c1d24] origin-left transform scale-x-0 transition-transform duration-300 ease-out group-hover:scale-x-100 -z-10"></span>
             <a href="/catalouge" >Catalouge</a>
          </button>
        </div>
        
      </div>
    </div>
  );
};

export default AboutSection;